import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.array.find";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import healthStatusMixin from '@/components/core/virtualDevice/healthStatusMixin';
import ApiService from '@/services/apiService';
import NiotaClassicApiService from '@/services/niotaClassicApiService';
export default {
  name: 'ViewISHeatMonitoringMeterList',
  mixins: [healthStatusMixin],
  data: function data() {
    return {
      showDialogStatistics: false,
      favouriteFilter: false,
      showDialogCreate: false,
      showDialogEditAll: false,
      selectedAccounts: [],
      selectedRows: [],
      //
      searchItems: [],
      searchGroups: [],
      searchTags: [],
      searchZones: [],
      bridgeTypes: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    isTwinManager: function isTwinManager() {
      return this.permissions['DigitalTwin.manage'];
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    searchTypes: function searchTypes() {
      return [{
        text: this.$i18n_t('Common.id'),
        param: 'id'
      }, {
        text: this.$i18n_t('IS.HeatMonitoring.meterPointId'),
        param: 'meterPointId'
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.deviceId'),
        param: 'deviceId'
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.keyValue'),
        param: 'keyValue'
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.health'),
        param: 'health',
        items: []
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.deviceType'),
        param: 'deviceType',
        items: []
      }];
    },
    showAccountFilter: function showAccountFilter() {
      return this.permissions['IsHeatMonitoring.manage'] || this.permissions['all.manage'];
    }
  }),
  watch: {
    language: function language() {
      (this.searchTypes.find(function (item) {
        return item.param === 'health';
      }) || {}).items = this.healthStatusItems;
      (this.searchTypes.find(function (item) {
        return item.param === 'tag';
      }) || {}).items = this.searchTags;
      (this.searchTypes.find(function (item) {
        return item.param === 'zone';
      }) || {}).items = this.searchZones;
    }
  },
  mounted: function mounted() {
    this.getMultiFilterData();
  },
  methods: {
    updateList: function updateList() {
      this.$refs.list.fetchList();
    },
    updateRowsSelected: function updateRowsSelected(rows) {
      this.selectedRows = rows;
    },
    getMultiFilterData: function getMultiFilterData() {
      var _this2 = this;

      (this.searchTypes.find(function (item) {
        return item.param === 'health';
      }) || {}).items = this.healthStatusItems;
      ApiService.isHeatMonitoringFetchTagsAndZones(this, 'meter').then(function (result) {
        _this2.searchTags = result.tagList;
        _this2.searchZones = result.zoneList;
        (_this2.searchTypes.find(function (item) {
          return item.param === 'tag';
        }) || []).items = result.tagList;
        (_this2.searchTypes.find(function (item) {
          return item.param === 'zone';
        }) || []).items = result.zoneList;
      }).catch(function (error) {
        console.error(error);
      });
      NiotaClassicApiService.deviceTypesGetPlain().then(function (res) {
        (_this2.searchTypes.find(function (item) {
          return item.param === 'deviceType';
        }) || {}).items = res.data.devicetypes.map(function (dt) {
          return {
            value: dt.id,
            text: dt.title,
            id: dt.id
          };
        });
      }).catch(function (error) {
        _this2.$snack(_this2.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');

        console.error(error);
      });
    },
    openDeviceWizard: function openDeviceWizard() {
      this.showDialogCreate = true;
    },
    fillMeterDefaults: function fillMeterDefaults(meterModel) {
      meterModel.title = 'Smartmeter Device';
      meterModel.data.keyValue['heatmonitoring_create_unit'] = 'kWh';
      meterModel.data.keyValue['heatmonitoring_create_key'] = 'meter_value';
    },
    createMeter: function () {
      var _createMeter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.showDialogCreate = false;
                this.updateList();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createMeter() {
        return _createMeter.apply(this, arguments);
      }

      return createMeter;
    }()
  }
};